var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 2,
    viewBox: "0 0 14 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1C0 0.734784 0.138281 0.480429 0.384422 0.292893C0.630564 0.105357 0.964403 0 1.3125 0H12.6875C13.0356 0 13.3694 0.105357 13.6156 0.292893C13.8617 0.480429 14 0.734784 14 1C14 1.26522 13.8617 1.51957 13.6156 1.70711C13.3694 1.89464 13.0356 2 12.6875 2H1.3125C0.964403 2 0.630564 1.89464 0.384422 1.70711C0.138281 1.51957 0 1.26522 0 1Z",
    fill: "#DADADA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIcon);
export default __webpack_public_path__ + "static/media/minusIcon.dc9f0a0093c224834f431fc08e87bebb.svg";
export { ForwardRef as ReactComponent };